import { IconButton, SvgIcon } from '@mui/material';
import { FC } from 'react';
import CloseIcon from '../../../../icons/svg/close.svg?react';

type Props = {
  onCloseIconClick: () => void;
};

export const CloseButton: FC<Props> = ({ onCloseIconClick }) => {
  return (
    <IconButton
      size="small"
      onClick={onCloseIconClick}
      disableRipple
      sx={{
        padding: '0px'
      }}
    >
      <SvgIcon
        component={CloseIcon}
        sx={{
          color: 'white',
          fontSize: '1.5rem'
        }}
      />
    </IconButton>
  );
};
